module.exports = __webpack_public_path__ + "static/img/6.a7fd9f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/6.jpg
// module id = Nv0Y
// module chunks = 0